<lds-card margin="none" padding="none">
  <div class="support">
    <h4 class="support__heading">We're here to help.</h4>
    <p class="support__text">
      Please contact your network manager or email
      <a href="mailto:sparksupport@mikepero.co.nz">sparksupport@mikepero.co.nz</a>.
    </p>
  </div>
</lds-card>
